import React from 'react';
import Icon from '../../../components/AppIcon';

const FinishSelector = ({ selectedFinish, onFinishChange }) => {
  const finishes = [
    { value: 'glossy', label: 'Glossy', icon: 'Sparkles', description: 'High shine finish' },
    { value: 'matte', label: 'Matte', icon: 'Circle', description: 'Flat finish' },
    { value: 'eggshell', label: 'Eggshell', icon: 'CircleDot', description: 'Subtle sheen' }
  ];

  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-text-primary">
        Select Finish
      </label>
      <div className="grid grid-cols-3 gap-3">
        {finishes?.map((finish) => (
          <button
            key={finish?.value}
            onClick={() => onFinishChange(finish?.value)}
            className={`
              p-4 rounded-lg border-2 transition-all duration-300
              hover:shadow-md
              ${selectedFinish === finish?.value 
                ? 'border-primary bg-primary/5' :'border-border bg-card'
              }
            `}
          >
            <div className="flex flex-col items-center gap-2">
              <Icon 
                name={finish?.icon} 
                size={24} 
                color={selectedFinish === finish?.value ? 'var(--color-primary)' : 'var(--color-text-secondary)'}
              />
              <span className={`text-sm font-medium ${
                selectedFinish === finish?.value ? 'text-primary' : 'text-text-primary'
              }`}>
                {finish?.label}
              </span>
              <span className="text-xs text-text-secondary text-center">
                {finish?.description}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FinishSelector;